module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "content"
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": {
        span: 6,
        offset: 9
      }
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n            欢迎登陆\n        ")]), _vm._v(" "), _c('el-row', [_c('el-input', {
    attrs: {
      "placeholder": "用户名",
      "type": "text"
    },
    model: {
      value: (_vm.signIn.username),
      callback: function($$v) {
        _vm.$set(_vm.signIn, "username", $$v)
      },
      expression: "signIn.username"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "密码",
      "type": "password"
    },
    model: {
      value: (_vm.signIn.password),
      callback: function($$v) {
        _vm.$set(_vm.signIn, "password", $$v)
      },
      expression: "signIn.password"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSignIn
    }
  }, [_vm._v("登陆")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("注册")]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "注册",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.signUp
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.signUp.username),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "username", $$v)
      },
      expression: "signUp.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.signUp.email),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "email", $$v)
      },
      expression: "signUp.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.signUp.password),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "password", $$v)
      },
      expression: "signUp.password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSignUp
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-737ebe2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 182
// module chunks = 1